import { RosteringComponent } from "./rostering.component";
import { CreateRosteringComponent } from "./create-rostering/create-rostering.component";
// import { ManualRosteringRoutingBreadcrumbs } from "../rostering-old/manual-rostering/manual-rostering.routing";


import { CreateRouteComponent } from "./create-route/createRoute.component";
import { ManageRouteComponent } from "./manage-route/manageRoute.component"
import { routeConfigRouting } from "./route-configuration/route-configuration.routing";
import { RosterComponent } from "./directives/roster/roster.component";
import { RosterNewComponent } from "./Roster/roster-new.component";
export const RosteringRouting = [
    { path: '', component: RosteringComponent },
    { path: 'roster', component: RosterNewComponent },
    { path: 're-route', children: [] },
    // { path: 'create', component: CreateRosteringComponent },
    {
        path: 'manage-route', children: [
            { path: '', component: ManageRouteComponent },
            { path: 'roster', component: RosterComponent },
            { path: 'configuration', children: routeConfigRouting }
        ]
    },

    {
        // path: 'create-route/:routeType', component: CreateRouteComponent
        path: 'create-route', children: [
            { path: ':routeType', component: CreateRouteComponent },
            { path: ':routeType/:id', component: CreateRouteComponent },

        ]
    },
    {
        path: 'edit-route', children: [{ path: ':routeType/:id/:regNo', component: CreateRouteComponent },]
    },
    {
        path: 'edit-route', children: [{ path: ':routeType/:id/:regNo/:gMap', component: CreateRouteComponent },]
    }
];


// export const RosteringRoutingBreadcrumb = [

//     { name: 'Rostering', path: '/rostering' },
//     { name: 'Manual', path: '/manual',children:ManualRosteringRoutingBreadcrumbs },
//     { name: 'Routes', path: '/routes' },
//     { name: 'Semi-automatic', path: '/semi-automatic' },


// ];